
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sponsors/[organizationId]/overview",
      function () {
        return require("private-next-pages/sponsors/[organizationId]/overview.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sponsors/[organizationId]/overview"])
      });
    }
  